import bg from "../assets/bg.jpeg";
import M from "../assets/M.png";
import gallery01 from "../assets/gallery01.jpeg";
import gallery02 from "../assets/gallery02.jpeg";
import gallery03 from "../assets/gallery03.jpeg";
import gallery04 from "../assets/gallery04.jpeg";
import gallery05 from "../assets/gallery05.jpeg";
import gallery06 from "../assets/gallery06.jpeg";
import gallery07 from "../assets/gallery07.jpeg";
import knife from "../assets/knife.png";
import menu from "../assets/menu.png";
import spoon from "../assets/spoon.svg";
import welcome from "../assets/welcome.png";

export default {
	bg,
	M,
	gallery01,
	gallery02,
	gallery03,
	gallery04,
	gallery05,
	gallery06,
	gallery07,
	knife,
	menu,
	spoon,
	welcome,
};
